import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader, baseUrl, stage } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import { useAuth } from './useAuth'

interface RoleRequestBody {
  representative: string[]
}

interface ResultRoleAdd {
  success: boolean
  message?: string
}

interface CG02RoleAddProps {
  execRoleAdd: (tenant: string, representativeUserIds: string[]) => Promise<ResultRoleAdd>
  loading: loadStatus
}

// CG02 ロール割当追加
export const useCG02RoleAdd = (): CG02RoleAddProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()

  const execRoleAdd = async (tenant: string, representativeUserIds: string[]) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }

      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })

      const body: RoleRequestBody = {
        representative: representativeUserIds,
      }

      const response = await axios.post(
        `${baseUrl}${stage}${apiUrl.tenantsPath}${tenant}/roles`,
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true }
      }

      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execRoleAdd, loading }
}
